const inputErrors = [...document.querySelectorAll('.j-form-validate-over .j-input-wrap')];

// TODO: Убрать скрипт, переписать через стили!!!
inputErrors.forEach((item) => {
    const input = item.querySelector('.input__input');

    item.addEventListener('click', () => {
        input.classList.remove('validate-input-error');
        input.focus();
    });
});
